import styled from "styled-components";

export const Icon = styled.div`
  width: 200px;
  height: 60px;
  background-size: contain;
  background-position: left center;
  background-repeat: no-repeat;
`;
